import { extend } from 'vee-validate';
import { required, email, integer, alpha_spaces, digits, min, max } from "vee-validate/dist/rules"

extend("required", {
  ...required,
  message: "This field is required"
});

extend("alpha_spaces", {
  ...alpha_spaces,
  message: "This field may only contain alphabetic characters"
});

extend("email", {
  ...email,
  message: "This email address is invalid"
});

extend("integer", {
  ...integer,
  message: "This field may only contain numeric characters"
});

extend("minName", {
  ...min,
  message: "Name must have at least 3 alphabetic characters"
});

extend("minPhone", {
  ...min,
  message: "Phone number must have at least 10 digits"
});

extend("NRIC", {
  ...digits,
  message: "NRIC number must be numeric and exactly contain 12 digits"
});

extend("fullName", (input, fullname) => {
  if(input === fullname[0]){
    return true;
  }
  return "Full Name must match with First Name and Last Name"
});

extend("confirmEmail", (input, email) => {
  if(input === email[0]){
    return true;
  }
  return "Email address does not match"
});

extend("minCity", {
  ...min,
  message: "City name must have at least 3 alphabetic characters"
});

extend("maxPhone", {
  ...max,
  message: "Phone number must not more than 11 digits"
});

extend('inputEmail', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Email confirmation does not match'
});
